export const TRAINING_TOOLTIPS = {
  filters: {
    search: 'Type a keyword to find a module by name (example: "Sanitation").',
    category: "Choose a category to narrow your training list.",
    status: "Filter by progress: Not started, In progress, or Completed.",
  },
  categories: {
    name:
      'Enter a category name to organize modules (example: "Receptionist Basics").',
    sortOrder: "Optional. Lower numbers appear first (example: 1, 2, 3).",
  },
  modules: {
    title:
      'Enter a clear module name (example: "Proper Disinfection Steps").',
    category: "Pick the category this module belongs to.",
    description: "Optional. Add a short summary of what staff will learn.",
    publish: "Publish when ready. Staff only see published modules.",
    republishVersion:
      "If you update a published module, republish to create a new version and request staff to acknowledge again.",
  },
  lessons: {
    title:
      'Enter the lesson title staff will click (example: "How to sanitize tools").',
    type: "Choose the lesson format: Video link, Document, or Website link.",
    videoUrl: "Paste a full video link (example: YouTube or Vimeo URL).",
    externalUrl: "Paste a website link for staff to read (example: policy page).",
    upload: "Upload a PDF/DOC/DOCX file for staff to open.",
    estimatedMinutes:
      "Optional. Estimate how long this lesson takes (example: 10 minutes).",
    sortOrder:
      "Optional. Controls lesson order in the module (example: 1, 2, 3).",
  },
  assignments: {
    targetType:
      "Choose who gets this training: a Role (group) or a Specific Staff member.",
    role: "Pick the role that should receive this module.",
    user: "Search and select the staff member who should receive this module.",
    module: "Select the module to assign.",
    assignedOn: "The date this training is assigned (uses salon timezone).",
    dueOn:
      "Optional. Set a due date to track overdue training (uses salon timezone).",
    priority: "Optional. High priority modules show at the top of staff lists.",
    required:
      "If required, staff should complete it before working independently.",
  },
  settings: {
    proEnabled:
      "Turn on Training Pro features like due dates, quizzes, and acknowledgements.",
    quizzesEnabled: "Allow quizzes at the end of modules to check knowledge.",
    certificatesEnabled:
      "Save a certificate record when a module is completed.",
    ackEnabled:
      "Require staff to confirm they read and understood the module.",
  },
  quiz: {
    prompt:
      'Write the question staff must answer (example: "What is the minimum disinfection time?").',
    choices: "Add 2-5 answers. Mark only one as correct.",
    passRule: "Staff pass when their score meets the minimum (example: 70%).",
    submit: "Submit your answers to get your score. Your best score is saved.",
  },
};
